module.exports = __webpack_public_path__ + "img/imgZXGH(29).4f264d5b.png";